import React from "react";
import { useSelector } from "react-redux";
import {
    IActiveTab,
    ServingStatus,
    IStatusBadgeCellRenderer,
    DeepDiveGridType,
    ProductModalType,
    ParentModule,
    SubModule,
} from "@ts/common-types";
import { IModal } from "../modals/CustomModal";
import { getActiveModule, getBadgeParams, titleCase } from "@ts/utils";
import TypeBadgeCellRenderer from "./TypeBadgeCellRenderer";

const StatusBadgeCellRenderer: React.FC<IStatusBadgeCellRenderer> = (
    params,
    deepDiveGridType
) => {
    const activeTab = useSelector((state: IActiveTab) => state.activeTab.value);
    const productModalType = useSelector(
        (state: IModal) => state.productModalType.value
    );
    const { activeModule } = getActiveModule();
    const servingStatus =
        params.data[
            ServingStatus[params.colDef.field as keyof typeof ServingStatus]
        ]?.toLowerCase();

    const campaignType = params.isTypeBadgeRequired
        ? params.data.targetingtype
        : "";

    return (
        <>
            {params.node.rowPinned ? (
                params.pinnedColumnValue
            ) : (
                <>
                    <span
                        style={
                            (activeTab === SubModule.KEYWORD ||
                                activeModule ===
                                    ParentModule.KEYWORD_ANALYTICS ||
                                deepDiveGridType === DeepDiveGridType.Keyword ||
                                productModalType ===
                                    ProductModalType.PRODUCTS_MODAL) &&
                            params.isBadgeRequired
                                ? {
                                      display: "grid",
                                      lineHeight: 2.12,
                                      fontSize: 12.5,
                                  }
                                : {
                                      lineHeight: 2.12,
                                  }
                        }
                    >
                        {activeTab === SubModule.CAMPAIGN ? (
                            <div>
                                {getBadgeParams(
                                    "text",
                                    "status",
                                    servingStatus,
                                    campaignType
                                )}
                            </div>
                        ) : null}
                        {deepDiveGridType === DeepDiveGridType.Keyword ||
                        productModalType === ProductModalType.PRODUCTS_MODAL ||
                        activeTab !== SubModule.CAMPAIGN ? (
                            <div
                                style={{
                                    height: 27,
                                }}
                            >
                                {titleCase(params.data[params.colDef.field])}
                            </div>
                        ) : null}
                        {params.isBadgeRequired && (
                            <div>
                                {params.isTypeBadgeRequired && (
                                    <TypeBadgeCellRenderer {...{ params }} />
                                )}
                                <div
                                    className={`badge text-secondary`}
                                    style={{
                                        width: "fit-content",
                                        border: `1px solid ${getBadgeParams(
                                            "color",
                                            "status",
                                            servingStatus,
                                            campaignType
                                        )}`,
                                    }}
                                >
                                    {getBadgeParams(
                                        "text",
                                        "status",
                                        servingStatus,
                                        campaignType
                                    )}
                                </div>
                            </div>
                        )}
                    </span>
                </>
            )}
        </>
    );
};

export default StatusBadgeCellRenderer;
